﻿
import { FormBuilder,emailValidator } from "@tulipinfo/tue";
import { WebApiUrls } from "./api/web-api-urls";
import { BusinessResultStatus, IBusinessResult } from "./shared/interface/business-result";
import { postJson } from "./shared/utils/http";
import { countdownButton } from "./shared/utils/count-down-button";
import { showErrorMessage } from "./shared/utils/show-error-message";
import { encrypt } from './shared/utils/encrypt';
import { geti18n } from './shared/utils/language';


const fb = new FormBuilder();

function initEmailForgot() {
    const emailForgotForm = fb.createForm('#email-forgot-form',{
        "EmailData.Email":{
            validators:[
                emailValidator({ message: geti18n('Invalid Format')})
            ]
        }
    });
    let btnSendEmailCode: HTMLButtonElement = document.querySelector('#btnSendEmailCode');

    function sendEmailCode() {
        if (emailForgotForm.get('EmailData.Email').isValid === false) {
            emailForgotForm.get('EmailData.Email').setFocus();
            emailForgotForm.get('EmailData.Email').validate();
            return;
        }
        let url = `${WebApiUrls.email.sendforgotcode}`;

        postJson<IBusinessResult>(url, { email: encrypt(emailForgotForm.get('EmailData.Email').value) }).subscribe(br => {
            if (br.status === BusinessResultStatus.Success) {
                countdownButton(btnSendEmailCode);
            } else {
                showErrorMessage(br);
            }
        });
    }

    //bind event
    btnSendEmailCode.addEventListener('click', () => {
        sendEmailCode();
    });
}
function initPhoneForgot() {
    const phoneForgotForm = fb.createForm('#phone-forgot-form');
    let btnSendPhoneCode: HTMLButtonElement = document.querySelector('#btnSendPhoneCode');

    function sendPhoneCode() {
        if (phoneForgotForm.get('PhoneData.Phone').isValid === false) {
            phoneForgotForm.get('PhoneData.Phone').setFocus();
            phoneForgotForm.get('PhoneData.Phone').validate();
            return;
        }
        let url = `${WebApiUrls.sms.sendforgotcode}`;

        postJson<IBusinessResult>(url, { mobile: encrypt(phoneForgotForm.get('PhoneData.Phone').value) }).subscribe(br => {
            if (br.status === BusinessResultStatus.Success) {
                countdownButton(btnSendPhoneCode);
            } else {
                showErrorMessage(br);
            }
        });
    }

    //bind event
    btnSendPhoneCode.addEventListener('click', () => {
        sendPhoneCode();
    });
}

const emailForgotFormEle = document.querySelector('#email-forgot-form');
const phoneForgotFormEle = document.querySelector('#phone-forgot-form');
if (emailForgotFormEle) {
    initEmailForgot();
} else if(phoneForgotFormEle) {
    initPhoneForgot();
}
